import React from 'react';
import { Toaster } from 'sonner';
import { FilesPanel } from './components/SmartFiles/FilesPanel';
interface AppProps {
  filesState?: 'ready' | 'loading' | 'empty' | 'error';
  rowDensity?: 'comfortable' | 'compact';
}
export function App({
  filesState = 'ready',
  rowDensity = 'comfortable'
}: AppProps) {
  const initialStatus = filesState === 'error' ? 'error' : filesState === 'loading' ? 'loading' : 'ready';
  return <div className="min-h-full w-full bg-[#f3f3f3] text-slate-900" data-id="element-0" data-mp="2rikmp3jx47ah">
      <main className="mx-auto w-full max-w-5xl px-4 py-6 lg:px-6 lg:py-10" data-id="element-1" data-mp="2mndryl8mmcxp">
        <FilesPanel key={`${filesState}-${rowDensity}`} initialStatus={initialStatus} compact={rowDensity === 'compact'} emptyFiles={filesState === 'empty'} data-id="element-2" data-mp="31bs11dwmyxmp" />
      </main>
      <Toaster position="bottom-right" richColors data-id="element-3" data-mp="28suw6sn6u7od" />
    </div>;
}